






















































































import Vue from 'vue';
import pxModal from '@/dex-shared/components/px-modal.vue';
import pxButton from '@/dex-shared/components/px-button.vue';

export default Vue.extend({
  components: {
    pxModal,
    pxButton,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    course: {
      type: Object,
      required: true,
    },
    group: {
      type: Object,
      required: true,
    },
    grouplessCourseBoards: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      addStrategies: {
        NEW_BOARD: 'newBoard',
        EXISTING_BOARD: 'existingBoard',
      },
      loading: false,
      addStrategy: null,
      description: null,
      boardId: null,
      existingBoardId: null,
    };
  },
  created() {
    this.loading = false;
    this.addStrategy = this.addStrategies.NEW_BOARD;
    this.description = null;
    this.boardId = null;
    this.existingBoardId = null;
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    async handleSubmit() {
      if (this.loading) return;
      this.loading = true;
      const boardAlreadyExists = this.course.courseBoardsByCourseId.nodes.find(
        courseBoard => {
          return courseBoard.board.id === parseInt(this.boardId);
        },
      );
      if (boardAlreadyExists) {
        alert(
          `Esta disciplina já existe neste curso. Selecione pelo grupo de Disciplina existente `,
        );
        this.loading = false;
        return;
      }
      const shouldCreateNewBoard =
        this.addStrategy === this.addStrategies.NEW_BOARD;
      const boardId = shouldCreateNewBoard
        ? parseInt(this.boardId)
        : this.existingBoardId;

      try {
        if (shouldCreateNewBoard) {
          await this.$store.dispatch('CREATE_COURSE_BOARD', {
            description: this.description,
            courseId: this.course.id,
            boardId: parseInt(this.boardId),
          });
        }

        const response = await this.$store.dispatch('UPDATE_GROUP', {
          groupId: this.group.id,
          groupInfo: {
            boardIds: [...this.group.boardIds, boardId],
          },
        });

        this.$store.dispatch('PULL_COURSE', this.course.id);
        this.$store.commit('UPDATE_GROUP_ENTITY', response.data.updateGroup);
        this.closeModal();
      } catch (e) {
        this.loading = false;
        alert(
          `Algo deu errado. Envie essas informações para os desenvolvedores: ${e}`,
        );
      }
    },
  },
});
